import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {AuthService} from '../../auth.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MustMatch} from '../../helpers/mustMatch';
import {ChangeDetectorRef} from '@angular/core';

@Component({
  selector: 'ngx-register',
  styleUrls: ['./signup.component.scss'],
  templateUrl: './signup.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignupComponent {
  errors = [];
  messages: string[] = [];
  signupComplete = false;
  errorsSignup = [];
  form: FormGroup;
  loadingRegister = false;
  formSubmitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private ref: ChangeDetectorRef,
    ) {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]],
    }, {
      validator: MustMatch('password', 'confirmPassword'),
    });
  }

  get f() {
    return this.form.controls;
  }

  get name() {
    return this.form.get('name');
  }

  get email() {
    return this.form.get('email');
  }

  get password() {
    return this.form.get('password');
  }

  get confirmPassword() {
    return this.form.get('confirmPassword');
  }

  get user() {
    return {
      fullName: this.name.value,
      email: this.email.value,
      password: this.password.value,
    };
  }

  async register() {
    this.errorsSignup = [];
    this.formSubmitted = true;
    if (this.form.invalid) {
      return 0;
    }
    this.loadingRegister = true;

    const [error] = await this.authService.signup(this.user);
    this.loadingRegister = false;
    if (error) {
      const errors = error.error.data.error.errors.map(err => {
        switch (err.message) {
          case 'EMAIL_EXISTS':
            err.message = 'Este email ya está en uso';
            break;
          case 'OPERATION_NOT_ALLOWED':
            err.message = 'Oops algo salió mal, intenta más tarde.';
            break;
          case 'TOO_MANY_ATTEMPTS_TRY_LATER':
            err.message = 'Demasiados intentos, intenta más tarde';
            break;
        }
        return err.message;
      });

      this.errorsSignup = errors;
      this.ref.detectChanges();
      return 0;
    }
    this.signupComplete = true;
    this.ref.detectChanges();
  }
}
